module.exports = __webpack_public_path__ + "static/media/protrend.9def9eef.png";